/*!

=========================================================
* Argon Dashboard React - v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col
} from "reactstrap";

import { useState } from 'react';
import { Redirect } from 'react-router-dom';
import axios from 'axios';

const UserRegister = () => {

  const [shouldRedirect, setShouldRedirect] = useState(false);

  const enviarDadosParaAPI = async (dadosFormulario) => {
    try {
      // 'https://reflora.app.br:5001/api/v1/user'
      const response = await axios.post('https://reflora.app.br:5001/api/v1/user', dadosFormulario);
      console.log(response.data); // Exemplo de como lidar com a resposta da API
    } catch (error) {
      console.error(error);
    }
  };

  const [dadosFormulario, setDadosFormulario] = useState({
    nome: '',
    usuario: '',
    email: '',
    senha:'',
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setDadosFormulario((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log("Acionando API!")
    enviarDadosParaAPI(dadosFormulario);
    setShouldRedirect(true);
  };

  return (
    <>
    {shouldRedirect && <Redirect to="/auth/begin" />}
    {
      <Col lg="6" md="8">
        <Card className="bg-secondary shadow border-0">
          <CardHeader className="bg-transparent pb-5">
            <div className="text-muted text-center mt-2 mb-4">
              <small>Inscreva-se com</small>
            </div>
            <div className="text-center">
              <Button
                className="btn-neutral btn-icon"
                color="default"
                href="#pablo"
                onClick={(e) => e.preventDefault()}
              >
                <span className="btn-inner--icon">
                  <img
                    alt="..."
                    src={
                      require("../../assets/img/icons/common/google.svg")
                        .default
                    }
                  />
                </span>
                <span className="btn-inner--text">Google</span>
              </Button>
            </div>
          </CardHeader>
          <CardBody className="px-lg-5 py-lg-5">
            <div className="text-center text-muted mb-4">
              <small>Ou inscreva-se com credenciais</small>
            </div>
            <Form role="form" onSubmit={handleSubmit}>
              <FormGroup>
                <InputGroup className="input-group-alternative mb-3">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-single-02" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input placeholder="Nome completo" type="text" name="nome" value={dadosFormulario.nome} onChange={handleChange} />
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <InputGroup className="input-group-alternative mb-3">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-circle-08" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input placeholder="Usuário" type="text" name="usuario" value={dadosFormulario.usuario} onChange={handleChange} />
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <InputGroup className="input-group-alternative mb-3">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-email-83" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input placeholder="Email" type="email" autoComplete="novo email" name="email" value={dadosFormulario.email} onChange={handleChange}
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <InputGroup className="input-group-alternative mb-3">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-key-25" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input placeholder="Senha" type="password" name="senha" value={dadosFormulario.senha} onChange={handleChange} />
                </InputGroup>
              </FormGroup>
              <Row className="my-4">
                <Col xs="12">
                  <div className="custom-control custom-control-alternative custom-checkbox">
                    <input
                      className="custom-control-input"
                      id="customCheckRegister"
                      type="checkbox"
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="customCheckRegister"
                    >
                      <span className="text-muted">
                        Eu concordo com a {" "}
                        <a href="#pablo" onClick={(e) => e.preventDefault()}>
                          política de privacidade.
                        </a>
                      </span>
                    </label>
                  </div>
                </Col>
              </Row>
              <div className="text-center">
                <Button className="mt-4" color="primary" type="submit">
                  Criar Usuário
                </Button>
              </div>
            </Form>
          </CardBody>
        </Card>
      </Col>
    }
    </>
  );
};

export default UserRegister;